module.exports = __webpack_public_path__ + "static/media/bg-banner_assinatura_digital_vendas.161f94ca.png";